type PartialBOMSearch = Partial<Omit<BOMSearch, "Parts">> & { Parts: Partial<BOMSearchPart>[] };

// Partial BOM is suitable for sending to API
export function getPartialBom(bom: BOMSearch): PartialBOMSearch {
    const { HashId, Name, Distributors, SortOrder, StockFilter, BatchSize, Parts: parts } = bom;
    const partialParts = Array.isArray(parts) ? parts.map(getPartialPart) : [];
    return { HashId, Name, Distributors, SortOrder, StockFilter, BatchSize, Parts: partialParts };
}

export function getPartialPart(part: BOMSearchPart): Partial<BOMSearchPart> {
    return {
        Id: part.Id,
        Key: part.Key,
        PartId: part.Id,
        PartNumber: part.PartNumber,
        PartNumberScrubbedNonMeaningful: part.PartNumberScrubbedNonMeaningful,
        ManufacturerId: part.ManufacturerId,
        RootManufacturerId: part.RootManufacturerId,
        ManufacturerName: part.ManufacturerName,
        Quantity: part.Quantity,
        SortNum: part.SortNum,
        PartClickHash: part.PartClickHash,
        InternalReferenceNumber: part.InternalReferenceNumber,
    };
}

export const bomSortFunctions: Record<BOMSortOrder, (part1: BOMSearchPart, part2: BOMSearchPart) => number> = {
    [BOMSortOrder.Default]: (part1: BOMSearchPart, part2: BOMSearchPart) => (part2.SortNum ?? 0) - (part1.SortNum ?? 0),
    [BOMSortOrder.Manufacturer_Asc]: (part1: BOMSearchPart, part2: BOMSearchPart) =>
        part1.ManufacturerName.localeCompare(part2.ManufacturerName),
    [BOMSortOrder.Manufacturer_Desc]: (part1: BOMSearchPart, part2: BOMSearchPart) =>
        part2.ManufacturerName.localeCompare(part1.ManufacturerName),
    [BOMSortOrder.PartNum_Asc]: (part1: BOMSearchPart, part2: BOMSearchPart) =>
        part1.PartNumber.localeCompare(part2.PartNumber),
    [BOMSortOrder.PartNum_Desc]: (part1: BOMSearchPart, part2: BOMSearchPart) =>
        part2.PartNumber.localeCompare(part1.PartNumber),
};
